module.exports = __webpack_public_path__ + "static/media/dashboard.2f5102ee.png";